import { render, staticRenderFns } from "./lookup.vue?vue&type=template&id=8058f570&scoped=true"
import script from "./lookup.vue?vue&type=script&lang=js"
export * from "./lookup.vue?vue&type=script&lang=js"
import style0 from "./lookup.vue?vue&type=style&index=0&id=8058f570&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8058f570",
  null
  
)

export default component.exports